import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const DEFAULT_VISIBLE: string[] = [
  'customer-hub',
  'service-report',
  'delivery-report',
  'submissions',
  'new-ticket',
  'reminders',
  'calendar',
  'appointments',
  'technician-requests',
  'dispatch',
];

interface DashboardPreferencesState {
  cardOrder: string[];
  hiddenCardIds: string[];
  setCardOrder: (ids: string[]) => void;
  toggleCard: (id: string) => void;
  reset: () => void;
}

export const useDashboardPreferences = create<DashboardPreferencesState>()(
  persist(
    (set, get) => ({
      cardOrder: DEFAULT_VISIBLE,
      hiddenCardIds: [],

      setCardOrder: (ids) => set({ cardOrder: ids }),

      toggleCard: (id) => {
        const { hiddenCardIds, cardOrder } = get();
        if (hiddenCardIds.includes(id)) {
          set({
            hiddenCardIds: hiddenCardIds.filter((h) => h !== id),
            cardOrder: cardOrder.includes(id) ? cardOrder : [...cardOrder, id],
          });
        } else {
          set({
            hiddenCardIds: [...hiddenCardIds, id],
            cardOrder: cardOrder.filter((c) => c !== id),
          });
        }
      },

      reset: () => set({ cardOrder: DEFAULT_VISIBLE, hiddenCardIds: [] }),
    }),
    { name: 'dashboard-preferences' },
  ),
);
